<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <v-row>
      <v-col cols="6">
        <v-autocomplete
          v-model="semVinculoSelecionado"
          :items="filtroVinculo"
          label="Filtrar itens Vinculados"
          clearable
        ></v-autocomplete>
      </v-col>

      <v-col cols="6">
        <v-autocomplete
          v-model="filtroVazioSelecionado"
          :items="filtroVazios"
          label="Filtrar Zerados:"
          clearable
        ></v-autocomplete>
      </v-col>
    </v-row>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Produtos Registrados'"
      :newRowmodalButtonText="'Novo Produto para Estoque'"
      :tableHeader="headers"
      :tableRows="itens"
      :isView="false"
      :isFinish="false"
      :isEdit="true"
      :isDel="true"
      :isPrint="true"
      v-on:datatable-print="gerarEtiqueta"
      v-on:datatable-newrow="abrirModalInserir"
      v-on:datatable-updaterow="abrirModalEditar"
      v-on:datatable-deleterow="deletarItem"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
      
    >
      <v-form v-model="isFormValid">
        <v-col cols="12">
          <AlertasModal
            :tipo="alertaModal.tipo"
            :texto="alertaModal.texto"
          ></AlertasModal>
        </v-col>
        <div v-if="modalCustomSize.isEdit == false">

          <v-row>
            <v-col cols="12">
              <v-autocomplete
                label="Lista de Produtos"
                :items="listaDeItens"
                v-model="itemSelecionado"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampo">
            <v-col cols="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="on"
                    v-model="modalCustomSize.actualEdit.nomeItem"
                    name="nomeItem"
                    label="Nome do Produto"
                    readonly
                    append-outer-icon="mdi-plus-thick"
                    @click:append-outer="moreItem()"
                  ></v-text-field>
                </template>
                <span>{{ modalCustomSize.actualEdit.nomeItem }}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <div v-if="modalCustomSize.actualEdit.estoque.length > 0">
            <v-row v-for="(item, i) in modalCustomSize.actualEdit.estoque" :key="i">
              <v-col cols="4">
                <v-text-field
                  v-model="item.loteItem"
                  name="loteItem"
                  label="Lote">
                </v-text-field>
              </v-col>

              <v-col cols="4">
                <v-text-field 
                  type="text"
                  v-mask="['##/##/####']"
                  placeholder="DD/MM/AAAA"
                  hint="Ex: 01/01/2021"
                  label="Validade"
                  v-model="item.validadeItem"
                  :rules="[rules.dataCampo]"
                  @change="verificaValidade(item.validadeItem)">
                </v-text-field>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  v-model="item.quantidadeTotal"
                  name="quantidadeTotalItem"
                  label="Qt. em Estoque"
                  @keypress="event => filter(event)"
                  append-outer-icon="mdi-minus-thick"
                  @click:append-outer="deleteItem(i)">
                </v-text-field>
              </v-col>
            </v-row>
          </div>
        </div>

        <div v-if="modalCustomSize.isEdit == true">
          <v-row>
            <v-col cols="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="on"
                    v-model="modalCustomSize.updateData.nomeItem"
                    name="nomeItem"
                    label="Nome do Produto"
                    readonly
                  ></v-text-field>
                </template>
                <span>{{ modalCustomSize.updateData.nomeItem }}</span>
              </v-tooltip>
            </v-col>

            <v-col cols="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="on"
                    v-model="modalCustomSize.updateData.descricaoItem"
                    name="descricaoItem"
                    label="Descrição do Produto"
                    readonly
                  ></v-text-field>
                </template>
                <span>{{ modalCustomSize.updateData.descricaoItem }}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="modalCustomSize.updateData.loteItem"
                name="loteItem"
                label="Lote"
              ></v-text-field>
            </v-col>

            <v-col cols="3">              
              <v-text-field 
                type="text"
                v-mask="['##/##/####']"
                placeholder="DD/MM/AAAA"
                hint="Ex: 01/01/2021"
                label="Validade"
                v-model="modalCustomSize.updateData.validadeItem"
                :rules="[rules.dataCampo]"
              >
              </v-text-field>
            </v-col>

            <v-col cols="3">
              <v-text-field
                v-model="modalCustomSize.updateData.quantidadeEstoqueItem"
                name="quantidadeTotalItem"
                label="Qt. em Estoque"
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <v-text-field
                v-model="modalCustomSize.updateData.quantidadeNovaEstoque"
                name="quantidadeNovaEstoqueItem"
                label="Qt. Nova"
                @keypress="event => filter(event)"
              ></v-text-field>
            </v-col>

            <v-expand-transition>
              <!-- <v-col cols="12" v-if="($store.state.numeroEndereco != '116' && $store.state.numeroEndereco != '122' && $store.state.numeroEndereco != '61' && $store.state.numeroEndereco != '139' && $store.state.numeroEndereco != '93' && $store.state.numeroEndereco != '128')"> -->
              <v-col cols="12" v-if="($store.state.numeroEndereco == '118' || 
              $store.state.numeroEndereco == '42' ||
              $store.state.numeroEndereco == '43' ||
              $store.state.numeroEndereco == '44' ||
              $store.state.numeroEndereco == '45' ||
              $store.state.numeroEndereco == '46' ||
              $store.state.numeroEndereco == '47' ||
              $store.state.numeroEndereco == '48' ||
              $store.state.numeroEndereco == '49' ||
              $store.state.numeroEndereco == '50' ||
              $store.state.numeroEndereco == '51' ||
              $store.state.numeroEndereco == '52' ||
              $store.state.numeroEndereco == '53' ||
              $store.state.numeroEndereco == '54' ||
              $store.state.numeroEndereco == '55' ||
              $store.state.numeroEndereco == '117'||
              $store.state.numeroEndereco == '56' ||
              $store.state.numeroEndereco == '57')">
                <v-text-field v-model="modalCustomSize.updateData.senhaDispensa" label="Senha para liberação" @keypress="(event) => filter(event)"></v-text-field>
              </v-col>
            </v-expand-transition>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-radio-group
                row
                v-model="procuraPorNome"
              >
                <v-radio
                  label="Produtos Relacionados"
                  value="true"
                ></v-radio>
                <v-radio
                  label="Todos os Produtos"
                  value="false"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-expand-transition>
              <v-col v-if="mostrarItensParaVincular" cols="12">
                <v-autocomplete
                  v-model="numeroItemSistemaUnidade"
                  :items="listaItensParaVincular"
                  label="Produtos para Vincular"
                  autocomplete="off"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-expand-transition>

            <v-expand-transition>
              <v-col v-if="mostrarFamiliasParaVincular" cols="12">
                <v-autocomplete
                  v-model="modalCustomSize.updateData.indicadorStatusFamiliaSelecionado"
                  :items="listaDeFamilias"
                  label="Familias para Vincular"
                  autocomplete="off"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-expand-transition>
          </v-row>
        </div>
      </v-form>
    </ModalCustomSize>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <br>
     <br>
      <br>
       <br>
        <br>
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    SkeletonTable,
    Loading,
    ModalCustomSize,
    Alertas,
    AlertasModal,
    AlertaSnackbar
  },

  data: () => ({
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: null
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    isFormValid: false,

    showSkeletonTable: true,
    loading: false,
    mostrarCampo: false,
    mostrarItensParaVincular: false,
    mostrarFamiliasParaVincular: false,

    headers: [
      {
        text: "ID",
        value: "numeroItemUnidade",
      },
      {
        text: "Lote",
        value: "loteItem",
      },
      {
        text: "Nome do Produto",
        value: "nomeItem",
      },
      {
        text: "Descrição do Produto",
        value: "descricaoItem",
      },
      {
        text: "Validade",
        value: "validadeItem",
      },
      {
        text: "Quantidade em Estoque",
        value: "quantidadeEstoqueItem",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      size: "1400",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        descricaoTela: "EstoqueUnidade",
        numeroEndereco: store.state.numeroEndereco,
        numeroItem: null,
        numeroItemSistema: null,
        nomeItem: null,
        descricaoItem: null,
        estoque: [
          {
            loteItem: null,
            validadeItem: "",
            quantidadeTotal: null,
          },
        ],
      },
      updateData: {
        numeroEndereco: store.state.numeroEndereco,
        numeroItemUnidade: null,
        senhaDispensa: null,
        numeroItem: null,
        numeroItemSistema: null,
        numeroUnidade: null,
        nomeItem: null,
        descricaoItem: null,
        validadeItem: null,
        loteItem: null,
        quantidadeEstoqueItem: null,
        quantidadeNovaEstoque: null,

        procuraPorNome: false,
        numeroItemSistemaUnidade: null,
        indicadorStatusFamiliaSelecionado: null,
      }
    },

    itens: [],
    listaDeItens: [],
    listaItensParaVincular: [],
    listaDeFamilias: [
      {
        value: 1,
        text: "Medicações"
      },
      {
        value: 2,
        text: "Materiais"
      },
      {
        value: 3,
        text: "Psicotrópicos"
      },
      {
        value: 4,
        text: "Saneantes"
      },
      {
        value: 5,
        text: "Cosméticos"
      },
      {
        value: 6,
        text: "Nutrição "
      },
      {
        value: 7,
        text: "Antimicrobianos"
      },
      {
        value: 8,
        text: "Amostra Grátis",
      },
      {
        value: 9,
        text: "Maleta de Emergência",
      },
      {
        value: 10,
        text: "Doação",
      },
      {
        value: 11,
        text: "Teste Rápido"
      },
      {
        value: 12,
        text: "USO INTERNO"
      }
    ],
    filtroVazioSelecionado:false,
    filtroVazios: [
      {
        text: "Retornar Todos",
        value: false
      },
      {
        text: "Não Retornar Vazios",
        value: true
      },
    ],
    semVinculoSelecionado: false,
    filtroVinculo: [
      {
        text: "Retornar Todos",
        value: false
      },
      {
        text: "Retornar Somente Sem Vinculo",
        value: true
      },
    ],    
    itemSelecionado: null,
    numeroItemSistemaUnidade: null,
    procuraPorNome: null,
    dataVerificada: null,

    rules: {
      dataCampo: v => v.length >= 10 || 'Por favor insira a data completa!',
    },

  }),

  created() {
    this.inicializar();
  },

  watch: {
    itemSelecionado() {
      if (this.itemSelecionado) {
        const itemInserir = this.listaDeItens.filter((item) => item.value == this.itemSelecionado);
        this.itemSelecionado = null;

        this.modalCustomSize.actualEdit.numeroItem = itemInserir[0].numeroItem;
        this.modalCustomSize.actualEdit.numeroItemSistema = itemInserir[0].numeroItemSistema;
        this.modalCustomSize.actualEdit.nomeItem = itemInserir[0].nomeItem;
        this.modalCustomSize.actualEdit.descricaoItem = itemInserir[0].descricaoItem;
        this.modalCustomSize.actualEdit.estoque = []

        this.mostrarCampo = true;
      }
    },

    async procuraPorNome() {
      this.mostrarItensParaVincular = false

      if(this.procuraPorNome) {
        if(this.procuraPorNome == "true") {
          this.modalCustomSize.updateData.procuraPorNome = true
        } else if(this.procuraPorNome == "false") {
          this.modalCustomSize.updateData.procuraPorNome = false
        }
  
        await this.listarPorFiltro(this.modalCustomSize.updateData)
      }
    },

    numeroItemSistemaUnidade() {
      if(this.numeroItemSistemaUnidade) {
      
        this.modalCustomSize.updateData.numeroItemSistemaUnidade = this.numeroItemSistemaUnidade
        this.mostrarFamiliasParaVincular = true
      } else {
        this.mostrarFamiliasParaVincular = false
      }
    },

    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
    filtroVazioSelecionado() {
      this.listagemItensEstoque()
    },
    semVinculoSelecionado(){
      this.listagemItensEstoque()
    }
  },

  methods: {
    inicializar() {
      this.listagemItensEstoque()
      this.listagemItens()
    },

    gerarEtiqueta(item){
      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
          pageSize: {
            width: 93,
            height: 'auto'
          },
          pageOrientation: 'portrait',
          pageMargins: [ 3, 5, 80, 0 ],
          info: {
            title: "Comprovante Entrega",
          },
          content: [
            {
              text:
               
                item.nomeItem,
                pageOrientation: 'portrait'
            },
            {
              text:
                "Lt: " +
                item.loteItem,
                pageOrientation: 'portrait'
            },
            {
              text:
                "Val: " +
                item.validadeItem,
                pageOrientation: 'portrait'
            },
          ],
          defaultStyle: {
            fontSize: 1.6,
            // alignment: 'justify'
          },
        };

        pdfMake.createPdf(docDefinition).open();

    },

    async listagemItensEstoque() {
      this.showSkeletonTable = true;
      try {
        let response = await axios.put("listEstoqueUnidade", { numeroEndereco: store.state.numeroEndereco, semVazios: this.filtroVazioSelecionado, semVinculo: this.semVinculoSelecionado }, this.config);
        
        this.itens = response.data
      } catch (error) {
        console.log(error)
        this.alerta.texto = "Não foi possivel listar Estoque Unidade";
        this.alerta.tipo = "erro";
      } finally {
        this.showSkeletonTable = false;
        this.itemSelecionado = null;
      }
    },

    async listagemItens() {
      try {
        let response = await axios.put("itemNotOnBlacklistUnidade", { numeroEndereco: store.state.numeroEndereco, }, this.config);
        this.listaDeItens = response.data.map((row) => {
          if(row.descricaoItem) {
            return { 
              value: row.numeroItemSistema,
              text: row.nomeItem,
              numeroItem: row.numeroItem,
              numeroItemSistema: row.numeroItemSistema,
              nomeItem: row.nomeItem + ' - ' + row.descricaoItem,
              descricaoItem: row.descricaoItem
            };
          } else {
            return { 
              value: row.numeroItemSistema,
              text: row.nomeItem,
              numeroItem: row.numeroItem,
              numeroItemSistema: row.numeroItemSistema,
              nomeItem: row.nomeItem,
              descricaoItem: row.descricaoItem
            };
          }
        });

      } catch (error) {
        console.log(error)
        this.alertaModal.texto = "Não foi possivel listar os produtos";
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = "Não foi possivel listar os produtos";
        this.alertaSnackbar.cor = "red";
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarPorFiltro(filtragem) {
      try {
        let response = await axios.put("searchItemSistemaUnidadeReceberItem", filtragem, this.config)
        console.log(response.data)
        this.listaItensParaVincular = response.data.map(itemSelecionado => {
          return {
            value: itemSelecionado.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: itemSelecionado.itemSistema.nomeItemSistema
          };
        });

        this.mostrarItensParaVincular = true
      } catch (error) {
        console.log(error)
        this.alertaModal.texto = "Não foi possivel listar produtos por filtro";
        this.alertaModal.tipo = "erro"
        this.alertaSnackbar.texto = "Não foi possivel listar produtos por filtro";
        this.alertaSnackbar.cor = "red";
        this.alertaSnackbar.mostrar = true;
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSize.isButtonsDisabled = true;

        if (this.modalCustomSize.isEdit) {
          await this.atualizarItem(this.modalCustomSize.updateData);
        } else {
          await this.inserirItem(this.modalCustomSize.actualEdit);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async inserirItem(item) {
      try { 
        let camposCompletos = false

        for (const value of item.estoque) {
          if(value.loteItem && value.validadeItem && value.quantidadeTotal) {
            camposCompletos = true
          } else {
            camposCompletos = false
          }
        }

        if(camposCompletos) {
          this.alertaModal.tipo = null

          await axios.post("estoqueUnidade", item, this.config);
          
          this.modalCustomSize.isOpen = false;
          this.listagemItensEstoque()

        } else {
          this.alertaModal.texto = "Erro, um dos campos está incompleto"
          this.alertaModal.tipo = "erro"
          this.modalCustomSize.isButtonsDisabled = false;
        }

      } catch (error) {
        this.alertaModal.texto = "Não foi possivel inserir um novo produto";
        this.alertaModal.tipo = "erro"
        this.alertaSnackbar.texto = "Não foi possivel inserir um novo produto";
        this.alertaSnackbar.cor = "red";
        this.alertaSnackbar.mostrar = true;
        this.modalCustomSize.isButtonsDisabled = false;
        this.itemSelecionado = null
      }
    },

    async atualizarItem(item) {
      try {
        if(item.loteItem && item.validadeItem) {
          this.alertaModal.tipo = null
          await axios.put("estoqueUnidade", item, this.config);

          this.modalCustomSize.isOpen = false;
          this.listagemItensEstoque()
        } else {
          this.alertaModal.tipo = "erro"
          this.alertaModal.texto = "Erro, um dos campos está incompleto"
          this.modalCustomSize.isButtonsDisabled = false;
        }
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro"
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.cor = "red";
        this.alertaSnackbar.mostrar = true;
        this.modalCustomSize.isButtonsDisabled = false;
      }
    },

    async deletarItem(item) {
      try {
        if(confirm("Você deseja realmente excluir esse Produto do Estoque?")) {
          this.erro = false;
          await axios.delete("estoqueUnidade", {
            data: item,
            headers: this.config.headers
          });
          this.listagemItensEstoque();

        } else {
          this.erro = false;
        }

      } catch (error) {
        console.log(error)
        this.alertaModal.texto = "Não foi possivel deletar o produto";
        this.alertaModal.tipo = "erro"
        this.alertaSnackbar.texto = "Não foi possivel deletar o produto";
        this.alertaSnackbar.cor = "red";
        this.alertaSnackbar.mostrar = true;
      }
    },

    //MODAL POPULATE FUNCTIONS
    abrirModalInserir() {
      this.loading = true
      this.itemSelecionado = "";
      this.mostrarCampo = false;
      this.alertaModal.tipo = null;

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.formTitle = "Novo Produto";
      this.modalCustomSize.buttonText = "Concluir";

      this.modalCustomSize.actualEdit.numeroItem = null;
      this.modalCustomSize.actualEdit.numeroItemSistema = null;
      this.modalCustomSize.actualEdit.nomeItem = null;
      this.modalCustomSize.actualEdit.descricaoItem = null;
      this.modalCustomSize.actualEdit.estoque = [];

      this.loading = false
    },

    abrirModalEditar(item) {
      this.loading = true
      this.alertaModal.tipo = null;

      this.numeroItemSistemaUnidade = item.numeroItemSistemaUnidade,
      this.modalCustomSize.updateData.numeroItemSistemaUnidade = item.numeroItemSistemaUnidade,
      this.modalCustomSize.updateData.indicadorStatusFamiliaSelecionado = item.indicadorStatusFamilia,
      this.modalCustomSize.updateData.numeroItemUnidade = item.numeroItemUnidade,
      this.modalCustomSize.updateData.numeroItem = item.numeroItem,
      this.modalCustomSize.updateData.numeroItemSistema = item.numeroItemSistema,
      this.modalCustomSize.updateData.numeroUnidade = item.numeroUnidade,
      this.modalCustomSize.updateData.nomeItem = item.nomeItem,
      this.modalCustomSize.updateData.descricaoItem = item.descricaoItem,
      this.modalCustomSize.updateData.validadeItem = item.validadeItem,
      this.modalCustomSize.updateData.loteItem = item.loteItem,
      this.modalCustomSize.updateData.quantidadeEstoqueItem = item.quantidadeEstoqueItem
      this.modalCustomSize.updateData.quantidadeNovaEstoque = null

      if(item.numeroItemSistemaUnidade) {
        this.procuraPorNome = "false"
        this.mostrarItensParaVincular = true
      } else {
        this.procuraPorNome = null
        this.mostrarItensParaVincular = false
      }

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = true;
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
      this.modalCustomSize.formTitle = "Produto selecionado";
      this.modalCustomSize.buttonText = "Concluir";
      this.loading = false
    },

    deleteItem(index) {
      this.modalCustomSize.actualEdit.estoque.splice(index, 1)
    },

    moreItem() {
      this.modalCustomSize.actualEdit.estoque.push({
        loteItem: null,
        validadeItem: "",
        quantidadeTotal: null
      });
    },

    filter: function(evt) {
      evt = (evt) ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      
      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    
    verificaValidade(data) {
      this.alertaModal.texto = null;
      this.alertaModal.tipo = null;
      this.dataVerificada = data.split("/")

      if(data) {
        if(this.dataVerificada[0] == 0 && this.dataVerificada[1] == 0 && this.dataVerificada[2] == 0) {
          this.alertaModal.texto = "";
          this.alertaModal.tipo = "";
          this.alertaSnackbar.mostrar = false;
          this.dataVerificada = data
        } else if(this.dataVerificada[0] > 31 || this.dataVerificada[0] <= 0) {
          this.alertaModal.texto = "Dia inserido na validade do produto é inválido.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Dia inserido na validade do produto é inválido.";
          this.alertaSnackbar.cor = "orange";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = true;
        } else if(this.dataVerificada[1] <= 0 || this.dataVerificada[1] > 12) {
          this.alertaModal.texto = "Mes inserido na validade do produto é inválido.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Mes inserido na validade do produto é inválido.";
          this.alertaSnackbar.cor = "orange";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = true;
        } else if(this.dataVerificada[2] <= 2018 || this.dataVerificada[2] >= 3000) {
          this.alertaModal.texto = "Ano inserido na validade do produto é inválido.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Ano inserido na validade do produto é inválido.";
          this.alertaSnackbar.cor = "orange";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = true;
        } else if(this.dataVerificada[2] > 2018 && this.dataVerificada[2] <= 2020) {
          this.alertaModal.texto = "Aviso, o ano inserido na validade do produto consta como vencido.";
          this.alertaModal.tipo = "aviso";
          this.alertaSnackbar.texto = "Aviso, o ano inserido na validade do produto consta como vencido.";
          this.alertaSnackbar.cor = "orange";
          this.alertaSnackbar.mostrar = true;
        } else {
          this.alertaModal.texto = "";
          this.alertaModal.tipo = "";
          this.alertaSnackbar.mostrar = false;
          this.dataVerificada = data
        }
      } else {
        this.alertaModal.texto = "";
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;
      }
      
    },
  },
};
</script>
